// extracted by mini-css-extract-plugin
export default {"wrap":"breadcrumbs_wrap__iwqy-"};